import { datadogRum } from '@datadog/browser-rum'

import { APP_VERSION, APP_ENVIRONMENT } from './constants'
import { isDev } from './utils/helpers'

// Only initialize RUM in production and over HTTPS (required for partitioned cookies)
if (!isDev && location.protocol === 'https:') {
  datadogRum.init({
    applicationId: '3e43727a-6f20-4924-bd54-a306fc4055ab',
    clientToken: 'pub14c63331d7120854c427300b93639358',
    site: 'datadoghq.com',
    service: 'finerconnect-map',
    env: APP_ENVIRONMENT,
    version: APP_VERSION,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input',
    // --- iframe/session fixes ---
    usePartitionedCrossSiteSessionCookie: true,
    sessionPersistence: 'cookie',
    allowFallbackToLocalStorage: true
  })

  // Debug log for iframe session cookie (suppressed in production builds)
  console.debug('Datadog RUM: Using partitioned cross-site session cookie for iframe compatibility')

  // Runtime verification: check if session cookie was created
  setTimeout(() => {
    const hasDatadogCookie = document.cookie.includes('_dd_s') || document.cookie.includes('_dd_r')
    if (!hasDatadogCookie) {
      console.warn('Datadog RUM: Session cookie not detected. Iframe sandbox restrictions may be blocking cookie access.')
    }
  }, 1000)

  datadogRum.startSessionReplayRecording()
}